const editorOnlyKeys = new Set(['expanded', 'currentLang', 'isCurrentProject']);
const implicitFalseKeys = new Set([
  'isInline', 'marginBottom', 'noMarginBottom', 'noQuestion', 'showastiles',
  'showAsTiles', 'multiLine', 'askForTestOrLiveMode', 'sendScreenshot',
  'showAsPercentage', 'isCorrectAnswer', 'isPreSelected', 'isChecked',
  'backgroundColor'
]);

// Property editors fill in absent defaults when they first mount. Those values
// have the same meaning as their absence in the stored form.
const implicitDefaults = {
  Text: {textSize: 'medium', textAlignment: 'left'},
  Headline: {headingCategory: 'h3'},
  Button: {iconPos: 'iconRight', alignment: 'right', buttonStyle: 'Text', actionMode: 'default'},
  Login: {buttonStyle: 'Text'},
  Navigation: {alignment: 'left', textAlignment: 'left'},
  'Step Navigation': {
    alignment: 'left', buttonColor: '#ffffff', buttonBackgroundColor: '#444444',
    activeColor: '#ffffff', activeBackgroundColor: '#0066cc'
  },
  'Part Info': {partInfo: 'metaInfo'},
  'Part Legend': {titleAlignment: 'left', textAlignment: 'left'},
  'List Match': {choiceLocation: 'panel'},
  Sensor: {display: 'line'},
  Video: {displayOption: 'upload'},
  Website: {displayOption: 'link', openInNewTab: true},
  'Progress Tracker': {headingCategory: 'h3', formElementType: 'Headline'}
};

const isEmptyOption = option => {
  if (!option || typeof option !== 'object') return false;
  const values = {...option};
  delete values.uuid;
  return Object.keys(values).every(key => normalize(values[key], key) === undefined);
};

function normalize(value, key = '', parent = null) {
  if (editorOnlyKeys.has(key) || value === null || value === '') return undefined;
  if (value === false && implicitFalseKeys.has(key)) return undefined;
  if (key === 'formElementType' && parent && value === parent.formElementTypeString) return undefined;
  if (key === 'buttonSizeMode' && parent && parent.showastiles && value === 'minheight') return undefined;
  const defaults = parent && implicitDefaults[parent.formElementTypeString];
  if (defaults && defaults[key] === value) return undefined;
  if (Array.isArray(value)) {
    if (key === 'options' && value.length === 1 && isEmptyOption(value[0])) return undefined;
    const items = value.map(item => normalize(item)).filter(item => item !== undefined);
    return items.length ? items : undefined;
  }
  if (value && typeof value === 'object') {
    const result = {};
    Object.keys(value).sort().forEach(childKey => {
      const child = normalize(value[childKey], childKey, value);
      if (child !== undefined) result[childKey] = child;
    });
    return Object.keys(result).length ? result : undefined;
  }
  return value;
}

export function formContentSnapshot(config) {
  return JSON.stringify(normalize(config) || {});
}

export const formDirtyStateMixin = {
  data() {
    return {
      formContentBaseline: null,
      automaticCorrectionPending: false
    };
  },
  computed: {
    currentFormContentSnapshot() {
      if (!this.initialLoaded || this.formContentBaseline === null) return null;
      return formContentSnapshot(this.config);
    }
  },
  watch: {
    // Observe content rather than relying on every control to emit a change.
    // Normalization keeps selection and implicit editor defaults clean.
    currentFormContentSnapshot() {
      this.refreshDirtyState();
    },
    'state.dirty': {
      handler() {
        if (this.currentFormContentSnapshot !== null && this.state.dirty &&
            !this.automaticCorrectionPending &&
            this.currentFormContentSnapshot === this.formContentBaseline) {
          this.state.dirty = false;
          return;
        }
        this.$emit('dirty', this.state.dirty);
        window.vFormDirtyState = this.state.dirty;
      }
    }
  },
  methods: {
    refreshDirtyState() {
      if (this.currentFormContentSnapshot !== null) {
        this.state.dirty = this.automaticCorrectionPending ||
            this.currentFormContentSnapshot !== this.formContentBaseline;
      }
    }
  }
};
